import React, { useEffect, useState } from "react";
import Button from "~components/Button";
import { SVG_LIBRARY } from "~components/Svg";
import ResponsiveImage from "~components/ResponsiveImage";
import PageHTMLElement from "~components/PageHTMLElement";
import styles from "./index.module.scss";

const LiveStreamNotification = ({ data }) => {
  const [count, setCount] = useState(data.frequency);
  const [ticker, setTicker] = useState(count);
  const [active, setActive] = useState(false);

  const onClose = () => setActive(false);

  useEffect(() => {
    let timer;
    const pingNotificationService = async () => {
      let notification;

      try {
        const response = await fetch("/bff/api/v1/livestream/notification");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        notification = await response.json();
      } catch (err) {
        // Retry in 60s in the worst case
        console.error(err);
        notification = {
          status: false,
          frequency: data.frequency,
        };
      }
      setCount(notification.frequency * 1000);
      if (notification.active) {
        setActive(notification.active);
      }
      setTicker(ticker + 1);
    };

    if (count) {
      timer = setTimeout(() => {
        pingNotificationService();
      }, count);
    }
    return () => clearTimeout(timer);
  }, [ticker]);

  return (
    <div
      className={`${styles.LiveStreamNotification} ${
        active ? styles.LiveStreamNotificationActive : ""
      }`}
    >
      <i className={styles.LiveStreamNotificationCloseIcon} onClick={onClose}>
        {SVG_LIBRARY["iconClose"]}
      </i>
      <div className={styles.LiveStreamNotificationContent}>
        <ResponsiveImage src={data.logo} />
        <div className={styles.LiveStreamNotificationContentInner}>
          <PageHTMLElement type="h3" value={data.title} />
          <PageHTMLElement type="p3" value={data.description} />
        </div>
        <Button {...data.button} />
      </div>
    </div>
  );
};

export default LiveStreamNotification;
